export const PopupsSymbol = Symbol('Popups')
export const PopupsLinkUtilsAPISymbol = Symbol('PopupsLinkUtilsAPI')

export const name = 'popups' as const
